// AWS Amplify Configuration for v6
// Simplified configuration - only required fields
export default {
  Auth: {
    Cognito: {
      userPoolId: "eu-west-2_kQ1iPA4Cv",
      userPoolClientId: "684piafe028n3hfpa2knpqnlr6",
      loginWith: {
        email: true
      }
    }
  },
  API: {
    GraphQL: {
      endpoint: "https://6so3utbzvbajnbovyoamehyxui.appsync-api.eu-west-2.amazonaws.com/graphql",
      region: "eu-west-2",
      defaultAuthMode: "userPool"
    }
  }
}

